import { ApiProperty } from "@nestjs/swagger";

export class tempLogReq {
    @ApiProperty()
    uid: string[];

}